export class HtmlEntities {
    public static decode(value: string): string {
        return value?.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    }
}
